import React, { useContext, useRef } from 'react';
import { useModal, connectModal } from '@gsa/afp-component-library';
import { useReactToPrint } from 'react-to-print';
import './AreqReviewVehicleBuild.scss';
import AreqReviewVehicleBuildDetail from './AreqReviewVehicleBuildDetail/AreqReviewVehicleBuildDetail';
import VehicleRequisitionContext from '../../../context/VehicleRequisitionContext/VehicleRequisitionContext';
import { RequisitionPrintPreviewModal } from '../../RequisitionPrintPreviewModal/RequisitionPrintPreviewModal';
import {
  REQUISITION_BUTTON_DROPDOWN_ACTIONS,
  RequisitionActionsButtonDropdown,
} from '../../RequisitionActions/RequisitionActionsButtonDropdown/RequisitionActionsButtonDropdown';

const PrintTest = React.forwardRef((props, ref) => {
  const {
    state: { draftRequisition },
  } = useContext(VehicleRequisitionContext);

  const { friendlyName, reqId, status } = draftRequisition || {};
  const todayFormatted = new Intl.DateTimeFormat('en-US').format(new Date());

  return (
    <div className="areq-summary-print" ref={ref}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          border: '1px dashed var(--fleet-primary-dark, #1A4480)',
          width: 'fit-content',
        }}
      >
        <div
          style={{
            marginTop: '0px',
            width: '800px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div style={{ padding: '5px' }}>
            <img
              height="30px"
              src="data:image/svg+xml;base64,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"
              alt="GSA Fleet"
            />
          </div>
          <div
            style={{
              color: '#000',
              fontSize: '22px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '130%',
            }}
          >
            Requisition Summary
          </div>
        </div>
        <div
          style={{
            padding: '10px',
            borderLeft: '1px dashed var(--fleet-primary-dark, #1A4480)',
          }}
        >
          <div className="header-col-label">DATE</div>
          <div
            style={{
              color: 'var(--fleet-ink, #1B1B1B)',
              fontSize: '15px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '162%',
            }}
          >
            {todayFormatted}
          </div>
        </div>
        <div
          style={{
            padding: '15px',
            paddingLeft: '12px',
            borderLeft: '1px dashed var(--fleet-primary-dark, #1A4480)',
          }}
        >
          <div className="header-col-label">REQUISITION STATUS</div>
          <div
            style={{
              color: 'var(--fleet-primary, #005EA2)',
              fontSize: '15px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '162%',
            }}
          >
            {status}
          </div>
        </div>
      </div>
      <div
        style={{
          border: '1px dashed var(--fleet-primary-dark, #1A4480)',
          background: 'var(--fleet-gray-3, #F6F6F6)',
          height: '150px',
          width: '1070px',
          padding: '20px',
        }}
      >
        <div
          style={{
            color: 'var(--fleet-ink, #1B1B1B)',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '135%',
          }}
        >
          REQUISITION NUMBER
        </div>
        <div
          style={{
            color: '#000',
            fontSize: '30px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '130%',
          }}
        >
          {reqId}
        </div>
        <div
          style={{
            color: 'var(--fleet-ink, #1B1B1B)',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '135%',
            marginTop: '15px',
          }}
        >
          REQUISITION NAME
        </div>
        <div
          style={{
            color: 'var(--fleet-ink, #1B1B1B)',
            fontSize: '17px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '162%',
          }}
        >
          {friendlyName}
        </div>
      </div>

      <AreqReviewVehicleBuildDetail printPreview />

      <div
        className="footer"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          borderTop: '3px solid black',
        }}
      >
        <div
          style={{
            textTransform: 'uppercase',
            color: 'var(--fleet-ink, #1B1B1B)',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: '162%',
          }}
        >
          General Services Administration
        </div>
        <div
          style={{
            textTransform: 'uppercase',
            color: 'var(--fleet-ink, #1B1B1B)',
            textAlign: 'right',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: '162%',
          }}
        >
          GSA 80002B 8/1982
        </div>
      </div>
    </div>
  );
});

export default function AreqReviewVehicleBuild() {
  const printRef = useRef(null);

  const {
    state: { currentStep },
  } = useContext(VehicleRequisitionContext);

  const displayAreqPrintPreviewModal = useModal();
  const DisplayAreqPrintPreviewModal = connectModal(
    RequisitionPrintPreviewModal,
  );

  const pageStyle = `
    @media print {
      * {
          color-adjust: exact !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
      }

      .header-col-label {
        color: var(--fleet-ink, #1B1B1B);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 135%;
      }
      .custom-review-wrapper {
        max-width: 1300px !important;
      }

      .review-detail div.usa-accordion__content.usa-prose {
        border: none !important;
        padding-right: 30px;
      }

      h2.usa-accordion__heading {
        display: none;
      }

      footer {
        position: fixed;
        bottom: 0;
      }      
    }
  `;

  const print = useReactToPrint({
    pageStyle,
    content: () => printRef.current,
  });

  return (
    <div id="areq-review-vehicle-build">
      <div className="header">
        <h2>{currentStep.text}</h2>
      </div>
      <p>
        Please review all entered information so far. If you would like to make
        any edits, you may select this &quot;Edit&quot; link on the right of
        each section or navigate back within the requisition.
      </p>

      <div className="print-button">
        <RequisitionActionsButtonDropdown
          menuItems={{
            [REQUISITION_BUTTON_DROPDOWN_ACTIONS.PRINT]: {
              onClick: () => displayAreqPrintPreviewModal.openModal(),
            },
          }}
        />
      </div>

      <AreqReviewVehicleBuildDetail printPreview />

      <div className="print-only" aria-hidden>
        <PrintTest ref={printRef} />
      </div>

      <DisplayAreqPrintPreviewModal
        isOpen={displayAreqPrintPreviewModal.isOpen}
        handleClose={displayAreqPrintPreviewModal.closeModal}
        handlePrint={print}
      />
    </div>
  );
}
